import { useEffect } from 'react';

interface SEOJsonLdProps {
  data: object | object[];
}

export function SEOJsonLd({ data }: SEOJsonLdProps) {
  const schemas = Array.isArray(data) ? data : [data];

  useEffect(() => {
    const insertedTags: HTMLScriptElement[] = [];

    schemas.forEach((schema, index) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = `json-ld-${index}`;
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      insertedTags.push(script);
    });

    return () => {
      insertedTags.forEach((tag) => {
        if (document.head.contains(tag)) {
          document.head.removeChild(tag);
        }
      });
    };
  }, []);

  return null;
}
